"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useChat = void 0;
var _reactRouterDom = require("react-router-dom");
var _ = require("./..");
var _shared = require("../../shared");
var _useGlobalBan2 = _interopRequireDefault(require("./useGlobalBan"));
var _useChannelSortOptionsFromQueryString = require("./useChannelSortOptionsFromQueryString");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var useChat = function useChat() {
  var history = (0, _reactRouterDom.useHistory)();
  var _useAuth = (0, _shared.useAuth)(),
    user = _useAuth.user,
    isAuthenticated = _useAuth.isAuthenticated;
  var _useInitChatClient = (0, _.useInitChatClient)({
      user: user,
      isAuthenticated: isAuthenticated
    }),
    chatState = _useInitChatClient.chatState,
    client = _useInitChatClient.client,
    dispatchChatAction = _useInitChatClient.dispatchChatAction,
    loadingChat = _useInitChatClient.loadingChat,
    chatUser = _useInitChatClient.chatUser;
  var _useInitChannels = (0, _.useInitChannels)({
      client: client,
      chatUser: chatUser,
      dispatchChatAction: dispatchChatAction
    }),
    isChatAllowed = _useInitChannels.isChatAllowed,
    channels = _useInitChannels.channels,
    loadingChannels = _useInitChannels.loadingChannels,
    unreadMessages = _useInitChannels.unreadMessages,
    unreadMentions = _useInitChannels.unreadMentions,
    setPerformRetry = _useInitChannels.setPerformRetry;
  var _useUpdateActiveChann = (0, _.useUpdateActiveChannel)({
      client: client
    }),
    isActivating = _useUpdateActiveChann.isActivating,
    activeChannelId = _useUpdateActiveChann.activeChannelId,
    setActiveChatUser = _useUpdateActiveChann.setActiveChatUser,
    resetActiveChat = _useUpdateActiveChann.resetActiveChat;
  var _useGlobalBan = (0, _useGlobalBan2.default)({
      client: client
    }),
    globalBan = _useGlobalBan.ban;
  var onOpenChat = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(accountId) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _.updateChatToMoveOnTop)({
                myChatWith: accountId
              });
            case 2:
              setActiveChatUser(accountId);
              history.push("/chat?".concat(_useChannelSortOptionsFromQueryString.SORT_CHANNEL_BY_QUERY_NAME, "=updated_at"));
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function onOpenChat(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    chatClient: client,
    chatState: chatState,
    loadingChat: loadingChat,
    isChatAllowed: isChatAllowed,
    loadingChannels: loadingChannels,
    activeChannelId: activeChannelId,
    isActivating: isActivating,
    setActiveChatUser: setActiveChatUser,
    onOpenChat: onOpenChat,
    resetActiveChat: resetActiveChat,
    unreadMessages: unreadMessages,
    unreadMentions: unreadMentions,
    setPerformRetry: setPerformRetry,
    channels: channels,
    globalBan: globalBan
  };
};
exports.useChat = useChat;